<template>
  <v-overlay :value="display" style="z-index: 999">
    <v-progress-circular indeterminate size="64" z-index="2000" />
  </v-overlay>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LoadingOverlay',
  computed: {
    ...mapState('LoaderStore', ['display'])
  }
}
</script>
